import { render, staticRenderFns } from "./CalendarioEscolar.vue?vue&type=template&id=6d184d8e&"
import script from "./CalendarioEscolar.vue?vue&type=script&lang=js&"
export * from "./CalendarioEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports